import { AxiosResponse } from 'axios';
import { parseError } from '@/features/common/helpers/errorParser';
import { useAxios } from '@/features/common/helpers/axios';
import { GlobalResponseType } from '@/features/common/types';
import i18n from '@/i18n';
import { ApiKeyScopeEnum } from '@/features/api-keys/types';

export const { axiosService, baseURL } = useAxios();

export interface ApiKeysResponseType {
  apiKey: string,
  scopes: ApiKeyScopeEnum[]
}

export interface ApiKeysRequestType {
  apiKey: string,
  scopes: ApiKeyScopeEnum[]
}

export interface ApiKeysScopesType {
  scopes: ApiKeyScopeEnum[]
}

const filterExceptionMessage = (err: GlobalResponseType): GlobalResponseType => {
  if (!err.errorType) return err;

  const messageKey = `apiKeys.errorMessages.${err.errorType}`;
  if (!i18n.te(messageKey)) return err;

  return {
    ...err,
    errorMessage: i18n.t(messageKey) as string,
  };
};

export const getApiKeys = async (): Promise<{
  data?: ApiKeysResponseType
} & GlobalResponseType> => {
  try {
    const response: AxiosResponse = await axiosService.get('/api-keys');

    return {
      successful: true,
      errorMessage: '',
      redirectUrl: '',
      data: response.data,
    };
  } catch (err) {
    return filterExceptionMessage(parseError(err));
  }
};

export const updateAPIScopes = async (
  scopes: ApiKeyScopeEnum[],
): Promise<{
  data?: ApiKeysResponseType
} & GlobalResponseType> => {
  try {
    const response: AxiosResponse = await axiosService.put(
      '/api-keys', {
        scopes,
      },
    );

    return {
      successful: true,
      errorMessage: '',
      redirectUrl: '',
      data: response.data,
    };
  } catch (err) {
    return filterExceptionMessage(parseError(err));
  }
};

export const generateNewAPIKey = async (): Promise<{
  data?: ApiKeysResponseType
} & GlobalResponseType> => {
  try {
    const response: AxiosResponse = await axiosService.post(
      '/api-keys',
    );

    return {
      successful: true,
      errorMessage: '',
      redirectUrl: '',
      data: response.data,
    };
  } catch (err) {
    return filterExceptionMessage(parseError(err));
  }
};
